/** Set on an email's preview once it has measured the message, in email px. */
export const EMAIL_HEIGHT_ATTRIBUTE = "data-email-height";
/** Marks an email card's subject and preheader header, which an opening email's flight slides out. */
export const EMAIL_ENVELOPE_ATTRIBUTE = "data-email-envelope";

/** How tall the email under a node body measured, in email px, or undefined before it has. */
export function measuredEmailHeight(nodeBody: Element | null) {
  const height = Number(
    nodeBody
      ?.querySelector(`[${EMAIL_HEIGHT_ATTRIBUTE}]`)
      ?.getAttribute(EMAIL_HEIGHT_ATTRIBUTE),
  );
  return height > 0 ? height : undefined;
}
